import React from 'react';
import PageHeader, { Highlight } from '../components/ui/PageHeader';
import { ARCH_CODE } from '../utils/codeTemplates';

const ArchitecturePage: React.FC = () => (
  <>
    <PageHeader
      title={<>Project <Highlight>Architecture</Highlight></>}
      subtitle="Folder structure, component hierarchy, and dependency overview"
    />

    {/* Tree view */}
    <div style={{ background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 'var(--radius-lg)', overflow: 'hidden', marginBottom: 24 }}>
      <div style={{ background: 'var(--surface2)', borderBottom: '1px solid var(--border)', padding: '10px 20px', fontSize: '0.78rem', fontWeight: 600, color: 'var(--text-muted)', fontFamily: 'var(--font-mono)' }}>
        architecture.md
      </div>
      <pre style={{ fontFamily: 'var(--font-mono)', fontSize: '0.8rem', lineHeight: 1.8, padding: '20px 24px', color: 'var(--text)', overflowX: 'auto', margin: 0 }}>
        {ARCH_CODE}
      </pre>
    </div>

    {/* Tech stack cards */}
    <h2 style={{ fontSize: '1rem', fontWeight: 700, marginBottom: 16 }}>Tech Stack</h2>
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 12 }}>
      {[
        { name: 'React 18',        role: 'UI Framework',      color: '#61dafb' },
        { name: 'TypeScript 5',    role: 'Type Safety',       color: '#3178c6' },
        { name: 'React Router 6',  role: 'Navigation',        color: '#e34f26' },
        { name: 'Zustand 4',       role: 'State Management',  color: '#ff6b35' },
        { name: 'React Native 0.73',role: 'Mobile Target',    color: '#00e5ff' },
        { name: 'Gradle 8.4',      role: 'Build System',      color: '#02303a' },
      ].map((t) => (
        <div key={t.name} style={{ background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 'var(--radius-md)', padding: 16, display: 'flex', alignItems: 'center', gap: 12 }}>
          <div style={{ width: 10, height: 10, borderRadius: '50%', background: t.color, flexShrink: 0 }} />
          <div>
            <div style={{ fontWeight: 700, fontSize: '0.85rem' }}>{t.name}</div>
            <div style={{ fontSize: '0.72rem', color: 'var(--text-muted)' }}>{t.role}</div>
          </div>
        </div>
      ))}
    </div>
  </>
);

export default ArchitecturePage;
